var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v("Internet Explorer Not Supported")]),_c('p',[_vm._v("This website cannot be used with Internet Explorer. Please use another browser such as FireFox, Chrome, or Edge to access this website.")])])
}]

export { render, staticRenderFns }